/**
 * L2-P2: moved to @miq/platform (services/data.service.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform'.
 */
export { DataService } from '@miq/platform';
